import React, { useEffect } from "react";
import moment from "moment-timezone";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import JobApplication from "src/components/JobApplication/JobApplication";
import LayoutProtected from "src/layouts/LayoutProtected";
import ForgotPassword from "src/pages/ForgotPassword/ForgotPassword";
import LoginPage from "src/pages/LoginPage/LoginPage";
import ResetPassword from "src/pages/ResetPassword/ResetPassword";

import { AuthProvider } from "../context/userContext";

import LazyPages from "./LazyPages";
const MainRoute: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    moment.tz.setDefault();
  }, [location.pathname]);
  return (
    <>
      <ToastContainer />
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<LayoutProtected />}>
            <Route path="dashboard" element={<LazyPages.DashboardPage />} />
            <Route path="settings" element={<LazyPages.SettingsPage />} />
            <Route path="office-users" element={<LazyPages.PrivateOffice />} />
            <Route
              path="office-users/archived"
              element={<LazyPages.ArchivedOffice />}
            />
            <Route
              path="office-users/:uuid"
              element={<LazyPages.OfficeView />}
            />
            <Route
              path="professional-users"
              element={<LazyPages.ProfessionalUser />}
            />
            <Route
              path="/admin/office-users/:officeUserUuid/contact/:contactUuid"
              element={<LazyPages.ContactSense />}
            />
            <Route path="statement" element={<LazyPages.Statement />} />
            <Route
              path="professional-users/:uuid"
              element={<LazyPages.ProfessionalView />}
            />
            <Route path="dashboard" element={<LazyPages.DashboardPage />} />
            <Route path="role-management">
              <Route path="" element={<LazyPages.RoleManagement />} />
              <Route path="add-role" element={<LazyPages.AddRole />} />
              <Route path="edit-role/:uuid" element={<LazyPages.AddRole />} />
              <Route path="view-role/:uuid" element={<LazyPages.ViewRole />} />
            </Route>
            <Route path="jobs/:uuid" element={<LazyPages.JobView />} />
            <Route path="calander" element={<LazyPages.Calander />} />
            <Route path="category" element={<LazyPages.Category />} />
            <Route path="referral" element={<LazyPages.Referral />} />
            <Route
              path="referral/:uuid"
              element={<LazyPages.SubReferralManagement />}
            />
            <Route path="notes" element={<LazyPages.Notes />} />
            <Route path="timesheet">
              <Route
                path="/admin/timesheet/"
                element={<LazyPages.Timesheet />}
              />
              <Route
                path="view-details/:uuid"
                element={<LazyPages.TimesheetView />}
              />
              <Route
                path="professional"
                element={<LazyPages.TimesheetProfessional />}
              />
              <Route
                path="job-details/:uuid/:professional_uuid"
                element={<LazyPages.TimesheetJobDetails />}
              />
              <Route
                path="time-sheet-details/:uuid"
                element={<LazyPages.TimesheetDetails />}
              />
            </Route>
            <Route path="job-application" element={<JobApplication />} />
            <Route path="notification" element={<LazyPages.Notification />} />
            <Route path="pay-range-bill-rate">
              <Route
                path="/admin/pay-range-bill-rate"
                element={<LazyPages.PayRangeAndBills />}
              />
              <Route
                path="add-pay-range-bill-rate"
                element={<LazyPages.AddPayRangeBillRate />}
              />
              <Route
                path="offices/:payScaleUuid"
                element={<LazyPages.PayScaleOffices />}
              />
              <Route
                path="transparency-model"
                element={<LazyPages.TransparencyModel />}
              />
              <Route
                path="transparency-model/add"
                element={<LazyPages.AddTransparencyPayScale />}
              />
              <Route path="referral-job" element={<LazyPages.ReferralJob />} />
              <Route path="bulk-hire" element={<LazyPages.BulkHire />} />
            </Route>
            <Route path="reports" element={<LazyPages.Reports />}></Route>
            <Route
              path="revenue-report"
              element={<LazyPages.RevenueReports />}
            ></Route>
            <Route
              path="revenue-report/:uuid"
              element={<LazyPages.RevenueReportsDetails />}
            ></Route>
            <Route
              path="revenue-report/manual-invoice-report/:uuid"
              element={<LazyPages.ManualInvoiceReport />}
            ></Route>
            <Route path="jobs" element={<LazyPages.Jobs />}></Route>
            <Route path="add-job" element={<LazyPages.PostJob />} />
            <Route path="edit-job/:uuid" element={<LazyPages.PostJob />} />
            <Route path="prospects" element={<LazyPages.Prospects />} />
            <Route
              path="prospects/import-log"
              element={<LazyPages.ProspectImportLog />}
            />
            <Route path="add-prospect" element={<LazyPages.AddProspects />} />
            <Route path="prospect/:uuid" element={<LazyPages.AddProspects />} />
            <Route
              path="prospect-details/:uuid"
              element={<LazyPages.ProspectView />}
            />
            <Route path="invoice-list" element={<LazyPages.MasterInvoice />} />
            <Route path="invoice">
              <Route path="/admin/invoice" element={<LazyPages.Invoice />} />

              <Route path="onAccount" element={<LazyPages.OnAccount />} />
              <Route
                path="onAccount/:uuid/:officeUuid"
                element={<LazyPages.OnAccountDetails />}
              />
              <Route path="creditMemo" element={<LazyPages.CreditMemo />} />
              <Route
                path="creditMemo/:uuid"
                element={<LazyPages.CreditMemoDetails />}
              />
              <Route
                path="/admin/invoice/:uuid"
                element={<LazyPages.InvoiceDetails />}
              />
              <Route
                path="/admin/invoice/job-info/:uuid/:invoiceUuid"
                element={<LazyPages.InvoiceJobInfo />}
              />
              <Route
                path="/admin/invoice/timesheet/:uuid/:week"
                element={<LazyPages.InvoiceTimesheetInfo />}
              />
            </Route>
            <Route
              path="jobs-assignments"
              element={<LazyPages.JobsAssignments />}
            />
            <Route
              path="jobs-assignments/:uuid"
              element={<LazyPages.JobsAssignmentsDetails />}
            />
            <Route
              path="jobs-cancelled"
              element={<LazyPages.JobsCancelled />}
            />
            <Route
              path="jobs-bulk-conversion"
              element={<LazyPages.BulkConversion />}
            />
            <Route
              path="jobs-bulk-conversion/:uuid"
              element={<LazyPages.BulkConversionDetails />}
            />
          </Route>
        </Routes>
      </AuthProvider>
    </>
  );
};

export default MainRoute;
